var _rect, _rect2, _circle, _circle2, _path, _text, _text2, _text3, _text4, _text5, _text6, _rect3, _g, _rect4, _text7, _text8, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzAccessModelsQrOpportunityPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 440,
    viewBox: "0 0 320 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz access models QR opportunity poster") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 318,
    height: 438,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D3E1F1",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 318,
    height: 96,
    rx: 22,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 39,
    r: 5,
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    r: 4,
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 60c1-8 5-11 10-11s9 3 10 11M46 52c6-1 10 2 12 8",
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 53,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 820,
    letterSpacing: 2.5
  }, "TALENTLENZ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 140,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.6
  }, "OPPORTUNITY")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 178,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 810
  }, "Senior Mine")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 208,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 810
  }, "Planner")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 238,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "Scan to view requirements")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 257,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "and submit your application.")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 286,
    width: 126,
    height: 126,
    rx: 12,
    fill: "#07152A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 299,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 299,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 369,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 340,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 342,
    width: 13,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 376,
    width: 15,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 376,
    width: 15,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 342,
    width: 10,
    height: 10
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 286,
    width: 114,
    height: 42,
    rx: 12,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 312,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 760
  }, "Apply securely")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 359,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Unique opportunity link")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 371,
    width: 90,
    height: 7,
    rx: 3.5,
    fill: "#BDD8F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzAccessModelsQrOpportunityPoster);
export default __webpack_public_path__ + "static/media/talentlenz-access-models-qr-opportunity-poster.e95e8821399e7ff6cfe2210819c3326a.svg";
export { ForwardRef as ReactComponent };